import styled from 'styled-components'

import { ProgressBarColorKeys, ProgressBarSizeKeys } from './progress-bar.types'

const TRACK_OPACITY = 0.38

const HEIGHT_MAP: Record<ProgressBarSizeKeys, string> = {
  medium: '0.8rem',
  small: '0.6rem',
}

export const Track = styled.div<{
  $color: ProgressBarColorKeys
  $size: ProgressBarSizeKeys
  $width: string
}>(({ theme, $color, $size, $width }) => ({
  // Note: the track is the bar color faded, drawn by a pseudo-element so the bar itself stays opaque
  '&::before': {
    backgroundColor: 'currentColor',
    content: '""',
    inset: 0,
    opacity: TRACK_OPACITY,
    position: 'absolute',
  },
  borderRadius: theme.border.radius['full'],
  color: theme.colors[`${$color}500`],
  display: 'block',
  flexShrink: 0,
  height: HEIGHT_MAP[$size],
  overflow: 'hidden',
  position: 'relative',
  width: $width,
}))

// Note: the bar always has the full width and slides in from the left, like Material UI's LinearProgress
export const Bar = styled.div<{ $percent: number }>(({ theme, $percent }) => ({
  backgroundColor: 'currentColor',
  height: '100%',
  insetInline: 0,
  position: 'absolute',
  transform: `translateX(-${100 - $percent}%)`,
  transition: `transform ${theme.transition.duration.md} linear`,
}))
